export default __webpack_public_path__ + "static/1-4432738423c921e407642c3164f42063.webp";